const columnsCustomized = [
    {
        title: "排序",
        dataIndex: "list_order",
        key: "list_order",
        width: "100px",
        scopedSlots: {customRender: "list_order"}
    },
    {
        title: "编号",
        dataIndex: "code",
        width: "250px",
        ellipsis: true,
        key: "code"
    },
    {
        title: "缩略图",
        dataIndex: "thumb",
        ellipsis: true,
        width: "100px",
        key: "thumb",
        scopedSlots: {customRender: "thumb"}
    },
    {
        title: "模板地址",
        dataIndex: "template_url",
        ellipsis: true,
        width: "180px",
        scopedSlots: {customRender: "template_url"},
        key: "template_url"
    },
    {
        title: "客户数",
        dataIndex: "customer_num",
        ellipsis: true,
        width: "100px",
        key: "customer_num"
    },
    {
        title: "定制客户",
        dataIndex: "customized_customer_name",
        width: "230px",
        ellipsis: true,
        key: "customized_customer_name"
    },
    {
        title: "关联状态",
        dataIndex: "customized_customer_related_name",
        width: "100px",
        ellipsis: true,
        key: "customized_customer_related_name"
    },
    {
        title: "设计师",
        dataIndex: "designer_name",
        width: "100px",
        ellipsis: true,
        key: "designer_name"
    },
    {
        title: "更新时间",
        dataIndex: "update_time",
        width: "150px",
        ellipsis: true,
        key: "update_time"
    },
    {
        title: "操作",
        key: "action",
        width: "200px",
        scopedSlots: {customRender: "action"}
    }
]

export default columnsCustomized
